import { useState, useRef, useEffect } from "react"
import { useBirddogLogout } from "../hooks/useBirddogLogout"
import { useBirddogRole } from "../hooks/useBirddogProfile"

const BirddogUserMenu = () => {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)
  const { mutateAsync: logout, isPending } = useBirddogLogout()
  const role = useBirddogRole()

  // For now, we'll use a placeholder name since we don't have full profile data yet
  // In the future, this could be fetched from the backend
  const userName = "User"

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isOpen])

  const handleLogout = async () => {
    try {
      await logout({})
    } catch (error) {
      console.error("Logout failed:", error)
    }
  }

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative flex items-center hover:cursor-pointer overflow-hidden text-white text-base leading-[1.50] tracking-[0.02em] px-2 py-4 ml-3"
      >
        <span className="truncate">{userName}</span>
        <svg
          className={`w-4 h-4 ml-1 mt-0.5 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 py-1 rounded-md bg-white ring-1 ring-black/5 min-w-32 z-50">
          <div className="px-4 py-2 border-b border-gray-200">
            <p className="text-sm font-medium text-gray-900">{userName}</p>
            <p className="text-xs text-gray-500 capitalize">
              {role === "forester"
                ? "Forester"
                : role === "timber_buyer"
                  ? "Timber Buyer"
                  : "User"}
            </p>
          </div>

          <button
            onClick={() => void handleLogout()}
            disabled={isPending}
            className="block px-4 py-2 text-sm leading-[1.50] tracking-[0.01em] text-gray-700 focus:ring-0 focus:underline hover:underline w-full text-left disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isPending ? "Logging out..." : "Logout"}
          </button>
        </div>
      )}
    </div>
  )
}

export default BirddogUserMenu
